module.exports = __webpack_public_path__ + "static/media/default_thumb.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/images/default/default_thumb.png
// module id = ./src/CSS/assets-minified/images/default/default_thumb.png
// module chunks = 0